import { render } from "./narvarr.vue?vue&type=template&id=5ef3fd79&scoped=true"
import script from "./narvarr.vue?vue&type=script&lang=js"
export * from "./narvarr.vue?vue&type=script&lang=js"

import "./narvarr.vue?vue&type=style&index=0&id=5ef3fd79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef3fd79"]])

export default __exports__